export const CHECKOUT_V2_BASE_PATH = "/v2";

export const CHECKOUT_V2_PRICE_ESTIMATE_METHOD = "POST";
export const CHECKOUT_V2_PRICE_ESTIMATE_SUFFIX = "price-estimate";
/** /v2/price-estimate */
export const CHECKOUT_V2_PRICE_ESTIMATE_PATH = `${CHECKOUT_V2_BASE_PATH}/${CHECKOUT_V2_PRICE_ESTIMATE_SUFFIX}`;
